import { graphql, useStaticQuery } from 'gatsby'
import './product.css'
import { Dropdown, Button, Responsive, Select} from 'semantic-ui-react'
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {loadStripe} from '@stripe/stripe-js';
import { breakpoints, spacing } from '../util/styles';
import Img from 'gatsby-image';
import { Router, Link } from "@reach/router"
import ProductListing from "../components/Products/ProductListing";
import Firebase from "../services/firebase";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
/** Used by CMS */
export class ProductPageTemplate extends React.Component {
  componentDidMount() {
    document.body.scrollTop = 0;
    document.querySelector('.menu').classList.remove('open');
  }

  constructor(props) {
    super(props);

    this.state = {
      skuSelection: "",
      isLoading:false

    };
    this.onSelect = this.onSelect.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.render = this.render.bind(this);
  }

  onSelect = (event, data) => {
    console.log(data.value);
    this.setState({ skuSelection: data.value });
  };

  addToCart = () => {
    if(!this.state.skuSelection){
      toast.error('⛔️ Please select an option', {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    let productJson  = window.localStorage.getItem("products")? JSON.parse(window.localStorage.getItem("products")): {"products":[]};
    let selectedDropdownInfo = {
      productId: this.props.productId,
      name: this.props.title,
      price: this.props.price,
      sku: this.state.skuSelection,
      image: this.props.image
    };
    productJson.products.push(selectedDropdownInfo);
    window.localStorage.setItem("products", JSON.stringify(productJson));

    toast.info('💳 Product Added To Cart', {
      position: "top-right",
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };


  render() {
  const {
    title,
    description,
    price,
    skuInfo,
    image
  } = this.props;
  console.log(this.props);

  //LOL
  const dropwdownInfo = skuInfo.map(sku=> sku.attributes? sku.attributes.map(s=>s.key +" "+s.value ).map(mod=>mod).join(" - "):"").filter(function(el) { return el; }).map(element=>{ return {key:element, value:element, text:element}});
  console.log(dropwdownInfo)
  let i = 0;
  dropwdownInfo.forEach(info=>{
    info.value = skuInfo[i].skuId;
    info.key = skuInfo[i].skuId;
    i++
  });

  console.log(dropwdownInfo);

  return (
    <Responsive>
    <div className="itemPageWrapper">
      <div className="container">
      <div className="itemImgWrapper" >
        {
          // TODO: How to show a CMS image?
          typeof image === 'string' ?
            <img src={image}
                 alt={'product'} />
            :
            <StyledImage
              fluid={image.childImageSharp.fluid} />
        }
      </div>
      <div className="itemInfoWrapper">

        <Link className="backLink" to ="/products">
            <span className="small">
              <svg fill="#000000" height="13" viewBox="0 0 18 15" width="13" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 10l5 5 5-5z"/>
                <path d="M0 0h24v24H0z" fill="none"/>
              </svg>
            </span>All Items
          <Router>
            <ProductListing path='/products' />
          </Router>
        </Link>



        <h3 className="itemName">{title}</h3>
        <p className="itemCost frm">${price}</p>
        <p className="description">
          {description}
        </p>
        <p className="seller frm">By <span>Good Music Good Times</span></p>
        <p>
        <Dropdown options={dropwdownInfo}   fluid
                  selection
                  onChange={this.onSelect}
                  placeholder="Options"/>
        </p>
        <Button color={"black"} onClick={this.addToCart}  className="reqTradeBtn normalBtn">Add To Cart</Button>
        <ToastContainer/>
      </div>
      </div>
    </div>
    </Responsive>
  )}
}

ProductPageTemplate.propType = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  productId: PropTypes.string,
  price: PropTypes.number,
  skuInfo: PropTypes.array,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
const ProductPageRoot = styled('div')`
  padding-bottom: ${spacing.md}px;

  @media (min-width: ${breakpoints.desktop}px) {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 110px);
    padding: ${spacing.xl}px;
    width: 100%;
  }
`;

const Container = styled(`div`)`
  @media (min-width: ${breakpoints.desktop}px) {
    align-items: flex-start;
    display: flex;
  }
`;

const Details = styled(`div`)`
  position: relative;

  @media (min-width: ${breakpoints.desktop}px) {
    display: flex;
    flex-direction: column;
    margin-right: -${spacing.xl}px;
    max-width: 400px;
    min-height: 490px;
  }
`;

export const StyledImage = styled(Img)`
  margin-right: ${spacing.lg}px;
  width: 440px;
  display: block;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.15);
`;

const ProductPage = ({ data }) => {
  const { markdownRemark: product } = data

  return (
    <ProductPageTemplate
      title={product.frontmatter.title}
      description={product.frontmatter.description}
      price={product.frontmatter.price}
      image={product.frontmatter.image}
      skuInfo={product.frontmatter.skuInfo}
    />
  );
}

ProductPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

/** Used by UI at runtime */
export const RuntimeProduct = (props) => {
  // console.time('all content query');
  const { products } = useStaticQuery(
    graphql`
          query AllProducts {
              products: allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "product-page"}}}) {
              edges {
                  node {
                  fields {
                      slug
                  }
                  id
                  frontmatter {
                      productId
                      title
                      description
                      price
                      image {
                            childImageSharp {
                            fluid(maxWidth: 1000, maxHeight: 1000) {
                                ...GatsbyImageSharpFluid
                            }
                            }
                        }
                      skuInfo {
                          skuId
                          attributes {
                              key
                              value
                          }
                      }
                      }
                  }
              }
          }
      }
      `);
  // console.timeEnd('all content query');
  // needs a dummy product for the build to compile since no productId is available

  let product = {
    frontmatter: {
      title: '',
      description: '',
      price: '',
      productId: "",
      skuInfo: [],
      image: {
        childImageSharp: {
          fluid: ''
        }
      },
    }
  };
  products.edges.forEach((edge) => {
    if (edge.node.id === props.productId) product = edge.node;
  });
  return (
    <ProductPageTemplate
      {...product.frontmatter}
    />
  )
}

export default RuntimeProduct;
